import { render, staticRenderFns } from "./CompanyHolidays.vue?vue&type=template&id=2dd1b7fe&scoped=true"
import script from "./CompanyHolidays.vue?vue&type=script&lang=js"
export * from "./CompanyHolidays.vue?vue&type=script&lang=js"
import style0 from "./CompanyHolidays.vue?vue&type=style&index=0&id=2dd1b7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1b7fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VDatePicker,VIcon,VMenu,VPagination,VTextField})
